export default "__VITE_ASSET__ChxE$nrW__"